export default __webpack_public_path__ + "static/media/footer.809d0e70.png";